// VSM Field Definitions - Shared across components
// This file contains the field definitions used in vehicle_status components

export const VSM_FIELDS = [
  { key: 'delete', label: ''},
  { key: 'details', label: ''},
  { key: 'name', label: 'Vehicle'},
  { key: 'vehicle_odo', label:'Odo'},
  { key: 'vehicle_fuel', label:'Fuel'},
  { key: 'vehicle_def', label:'DEF'},
  { key: 'vehicle_status', label:'Status'},
  { key: 'maintenance_status', label:'Maint Status'},
  { key: 'unifi_status', label:'Unifi'},
  { key: 'rta_status', label:'RTA Status'},
  { key: 'rta_work_order_status', label:'RTA WO Status'},
  { key: 'wheelchair', label:'WC'},
  { key: 'stayanddo', label:'S&D'},
  { key: 'tote', label:'Tote'},
  { key: 'current_mvmt_id', label: 'Current ID'},
  { key: 'current_mvmt_driver', label: 'Current Driver'},
  { key: 'confirmed_status', label: 'Driver Confirm'},
  { key: 'confirmed_by', label: 'Confirmed By'},
  { key: 'washbay_assignment', label: 'Washbay Assignment'},
  { key: 'current_start_base', label: 'Current Start'},
  { key: 'current_finish_base', label: 'Current Finish'},
  { key: 'current_mvmt_return_time', label: 'Current Return'},
  { key: 'current_mvmt_return_eta', label: 'Return ETA'},
  { key: 'current_mvmt_pickup', label:'Current Pickup', tenant_types: ['TBN'] },
  { key: 'current_mvmt_spot_time', label:'Current Spot Time', tenant_types: ['TBN'] },
  { key: 'current_mvmt_destination', label:'Current Destination', tenant_types: ['TBN'] },
  { key: 'last_dirty_time', label:'Last Dirty'},
  { key: 'last_cleaned_time', label:'Cleaned Time'},
  { key: 'last_cleaned_number', label:'Cleaned #'},
  { key: 'last_washed_time', label:'Washed Time'},
  { key: 'last_bathroom_cleaned_time', label:'Bathroom Cleaned'},
  { key: 'last_def_filled_time', label:'DEF Filled'},
  { key: 'last_diesel_filled_time', label:'Diesel Filled'},
  { key: 'last_fueled_time', label:'Last Fueled'},
  { key: 'last_maintenance_time', label:'Last Maint Time'},
  { key: 'last_washed_number', label:'Washed #'},
  { key: 'last_ready_time', label:'Last Ready'},
  { key: 'last_returned_time', label: 'Last Return'},
  { key: 'dump_date', label:'Dump Date'},
  { key: 'detailed_date', label:'Detailed Date'},
  { key: 'wrapped_date', label:'Wrapped Date'},
  { key: 'wrap_scheduled_time', label:'Wrap Scheduled'},
  { key: 'next_mvmt_start_base', label: 'Next Start'},
  { key: 'next_mvmt_start_finish_base', label: 'Next Start / Finish'},
  { key: 'next_mvmt_driver', label: 'Next Driver'},
  { key: 'next_mvmt_route_name', label: 'Next Route Name'},
  { key: 'next_mvmt_client_ref1_route', label: 'Reference'},
  { key: 'next_mvmt_driver_phone', label: 'Driver #'},
  { key: 'next_mvmt_id', label: 'Next ID'},
  { key: 'next_mvmt_booking_type', label:'Booking Type'},
  { key: 'next_mvmt_booking_category', label:'Booking Category', tenant_types: ['TBN'] },
  { key: 'next_mvmt_return_time', label:'Next Return'},
  { key: 'next_scheduled_time', label:'Scheduled Time'},
  { key: 'next_daily_scheduled_time', label:'Next Daily'},
  { key: 'next_scheduled_config', label:'Daily Schedule'},
  { key: 'next_mvmt_driver_time', label:'Next Driver Start'},
  { key: 'next_mvmt_driver_start', label:'Next Driver Start (TBN)', tenant_types: ['TBN'] },
  { key: 'next_mvmt_time', label:'Next Depart'},
  { key: 'next_mvmt_delta', label:'Departs In'},
  { key: 'next_mvmt_days', label:'#'},
  { key: 'next_mvmt_distance', label:'Miles'},
  { key: 'next_mvmt_client_ref1', label:'Customer'},
  { key: 'next_mvmt_pickup', label:'Next Pickup'},
  { key: 'next_mvmt_destination', label:'Next Destination'},
  { key: 'odometer', label:'Odometer'},
  { key: 'fuel_level', label:'Fuel'},
  { key: 'def_level', label:'DEF'},
  { key: 'notes', label: 'Notes'},
  { key: 'update_status', label: ''},
]

// Curated default column sets for tenant VSM settings "Reset to Default"
export const VSM_MAIN_DEFAULT_FIELD_KEYS = [
  'details',
  'name',
  'vehicle_status',
  'maintenance_status',
  'next_mvmt_id',
  'next_mvmt_driver',
  'next_mvmt_time',
  'next_mvmt_delta',
  'notes',
]

export const VSM_MOBILE_DEFAULT_FIELD_KEYS = ['name', 'vehicle_status', 'next_mvmt_delta']

export const VSM_HISTORY_DEFAULT_FIELD_KEYS = [
  'processed_time',
  'updated_by',
  'vehicle_status',
  'vehicle_name',
  'last_cleaned_time',
  'last_washed_time',
  'last_returned_time',
  'notes',
]

function defaultVisibleFieldsString(availableFields, defaultKeys) {
  if (!availableFields || !availableFields.length || !defaultKeys || !defaultKeys.length) return ''
  const availableKeys = new Set(availableFields.map(f => f.key))
  return defaultKeys.filter(k => availableKeys.has(k)).join(',')
}

export function defaultMainVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_MAIN_DEFAULT_FIELD_KEYS)
}

export function defaultMobileVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_MOBILE_DEFAULT_FIELD_KEYS)
}

export function defaultHistoryVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_HISTORY_DEFAULT_FIELD_KEYS)
}

// FI-2267: the spanish wash board (/vsm-es). its columns used to be hard-coded
// to these three, so a tenant with no visible_es_fields keeps exactly them and
// no wash bay screen changes until someone picks columns in Setup.
export const VSM_ES_DEFAULT_FIELD_KEYS = ['name', 'vehicle_status', 'next_mvmt_time']

// the board's spanish headers; a column without one shows its english label
export const VSM_ES_LABELS = {
  name: 'Vehículo',
  vehicle_status: 'Estado',
  maintenance_status: 'Estado de Mantenimiento',
  vehicle_odo: 'Odómetro',
  odometer: 'Odómetro',
  vehicle_fuel: 'Combustible',
  fuel_level: 'Combustible',
  current_mvmt_id: 'ID Actual',
  current_mvmt_driver: 'Conductor Actual',
  washbay_assignment: 'Bahía de Lavado',
  current_mvmt_return_time: 'Regreso Actual',
  current_mvmt_return_eta: 'Llegada Estimada',
  last_cleaned_time: 'Hora de Limpieza',
  last_washed_time: 'Hora de Lavado',
  last_bathroom_cleaned_time: 'Baño Limpiado',
  last_ready_time: 'Último Listo',
  last_returned_time: 'Último Regreso',
  next_mvmt_start_base: 'Próximo Inicio',
  next_mvmt_driver: 'Próximo Conductor',
  next_mvmt_id: 'Próximo ID',
  next_mvmt_booking_type: 'Tipo de Reserva',
  next_mvmt_return_time: 'Próximo Regreso',
  next_mvmt_time: 'Próxima Salida',
  next_mvmt_delta: 'Sale En',
  next_mvmt_client_ref1: 'Cliente',
  next_mvmt_pickup: 'Próxima Recogida',
  next_mvmt_destination: 'Próximo Destino',
  notes: 'Notas',
}

// row-action columns; the spanish board is read-only and has nothing to put in them
export const VSM_ES_EXCLUDED_KEYS = ['delete', 'details', 'update_status']

export function esBoardFields(visibleEsFields) {
  const configured = (visibleEsFields || '').split(',')
    .map(k => k.trim())
    .filter(k => k && !VSM_ES_EXCLUDED_KEYS.includes(k))
  const keys = configured.length ? configured : VSM_ES_DEFAULT_FIELD_KEYS
  return keys.map(key => {
    const field = VSM_FIELDS.find(f => f.key === key)
    return { key, label: VSM_ES_LABELS[key] || (field && field.label) || key }
  })
}

export function defaultEsVisibleFieldsString(availableFields) {
  return defaultVisibleFieldsString(availableFields, VSM_ES_DEFAULT_FIELD_KEYS)
}

// FI-2156: what a board actually shows a tenant who has never configured
// columns -- the board's own catalog entries flagged `visible`, in catalog
// order, which is what `this.fields.filter(field => field.visible)` resolves
// to at the bottom of every board's visibleFields(). The two drop lists
// mirror the trims check_features() applies to `fields` per surface -- the
// portal branch and the standalone (tv / kiosk) branch. The role trim the
// dvir boards also apply is not mirrored: Setup is an admin page.
//
// Setup seeds its Customize Columns modals from these rather than from the
// curated sets above: those are the columns we would hand a new customer, and
// showing them as an unconfigured tenant's current selection meant dragging a
// single field into the list wrote that nine-column set over a board that had
// been rendering forty. The curated sets stay behind "Reset to Default".
//
// Each list was read off its board's own catalog. To re-derive one after a
// board's `fields` array changes, take the entries carrying `visible: true`,
// in catalog order, de-duplicated (the cm and dvir catalogs each carry two
// odo / fuel / def slots), then apply that board's check_features() trims.
export const VSM_BOARD_NO_CONFIG_FIELDS = {
  vehicle_status: {
    keys: [
      'delete', 'details', 'name', 'vehicle_odo', 'vehicle_fuel', 'vehicle_def',
      'vehicle_status', 'unifi_status', 'vehicle_tags', 'current_mvmt_id',
      'current_mvmt_driver', 'confirmed_status', 'confirmed_by',
      'washbay_assignment', 'current_start_base', 'current_finish_base',
      'current_mvmt_return_time', 'current_mvmt_return_eta',
      'current_mvmt_return_delta', 'last_dirty_time', 'last_cleaned_time',
      'last_cleaned_number', 'last_washed_time', 'last_bathroom_cleaned_time',
      'last_def_filled_time', 'last_diesel_filled_time', 'last_washed_number',
      'last_ready_time', 'last_returned_time', 'next_mvmt_start_base',
      'next_mvmt_start_finish_base', 'next_mvmt_route_name', 'next_mvmt_driver',
      'next_mvmt_client_ref1_route', 'next_mvmt_driver_phone', 'next_mvmt_id',
      'next_mvmt_booking_type', 'next_scheduled_time',
      'next_daily_scheduled_time', 'next_scheduled_config',
      'next_mvmt_driver_time', 'next_mvmt_time', 'next_mvmt_delta',
      'next_mvmt_days', 'next_mvmt_distance', 'next_mvmt_client_ref1',
      'next_mvmt_pickup', 'next_mvmt_destination', 'notes', 'update_status',
    ],
    portal_drop: [],
    standalone_drop: [],
  },
  vehicle_status_tbn: {
    keys: [
      'delete', 'details', 'name', 'vehicle_status', 'vehicle_tags',
      'current_mvmt_id', 'current_mvmt_driver', 'current_start_base',
      'current_finish_base', 'current_mvmt_return_time', 'last_fueled_time',
      'last_dirty_time', 'last_cleaned_time', 'last_cleaned_number',
      'last_washed_time', 'last_washed_number', 'last_ready_time',
      'last_returned_time', 'next_mvmt_start_base', 'next_mvmt_route_name',
      'next_mvmt_driver', 'next_mvmt_driver_start', 'next_mvmt_id',
      'next_mvmt_booking_category', 'next_scheduled_time', 'next_mvmt_time',
      'next_mvmt_delta', 'next_mvmt_return_time', 'notes', 'update_status',
    ],
    // check_features() swaps the row's action column by surface: the portal
    // drops the standalone board's oversized "Update Status" button, the
    // standalone board drops the portal's details expander
    portal_drop: ['update_status'],
    standalone_drop: ['details'],
  },
  vehicle_status_maint: {
    keys: [
      'last_dirty_time', 'last_cleaned_time', 'last_cleaned_number',
      'last_washed_time', 'last_washed_number', 'current_mvmt_return_time',
      'next_mvmt_destination',
    ],
    portal_drop: [],
    standalone_drop: [
      'delete', 'details', 'processed_time', 'last_out_time', 'last_dirty_time',
      'last_cleaned_time', 'last_cleaned_number',
    ],
  },
  vehicle_status_maint_tbn: {
    keys: [
      'last_dirty_time', 'last_cleaned_time', 'last_cleaned_number',
      'last_washed_time', 'last_washed_number', 'current_mvmt_return_time',
      'next_mvmt_driver_start', 'next_mvmt_days',
    ],
    portal_drop: [],
    standalone_drop: [
      'details', 'processed_time', 'last_out_time', 'last_dirty_time',
      'last_cleaned_time', 'last_cleaned_number',
    ],
  },
  vehicle_status_dvir: {
    keys: [
      'vehicle_odo', 'vehicle_fuel', 'vehicle_def', 'vehicle_status',
      'unifi_status', 'current_mvmt_id', 'current_mvmt_driver',
      'current_mvmt_return_time', 'current_mvmt_return_eta',
      'current_mvmt_return_delta', 'next_mvmt_start_finish_base',
      'next_mvmt_route_name', 'next_mvmt_start_base', 'next_mvmt_finish_base',
    ],
    portal_drop: [],
    standalone_drop: [
      'details', 'processed_time', 'last_out_time', 'last_dirty_time',
      'last_cleaned_time', 'last_cleaned_number',
    ],
  },
  vehicle_status_dvir_tbn: {
    keys: [
      'current_mvmt_id', 'current_mvmt_driver', 'current_mvmt_return_time',
      'current_mvmt_return_eta', 'current_mvmt_pickup',
      'current_mvmt_pickup_time', 'current_mvmt_spot_time',
      'current_mvmt_destination', 'next_mvmt_driver_start', 'next_mvmt_days',
      'next_mvmt_pickup', 'next_mvmt_destination',
    ],
    portal_drop: [],
    standalone_drop: [
      'details', 'processed_time', 'last_out_time', 'last_dirty_time',
      'last_cleaned_time', 'last_cleaned_number',
    ],
  },
  vehicle_status_dvir_fasttrak: {
    keys: [
      'current_mvmt_return_time', 'current_mvmt_return_eta',
      'current_mvmt_return_delta', 'next_mvmt_start_finish_base',
      'next_mvmt_start_base', 'next_mvmt_finish_base',
    ],
    portal_drop: [],
    standalone_drop: [
      'details', 'processed_time', 'last_out_time', 'last_dirty_time',
      'last_cleaned_time', 'last_cleaned_number',
    ],
  },
}

// The settings each Setup surface reads before its board gives up, in the
// board's own order. The standalone surfaces fall through
// visible_standalone_fields and then the portal list, matching the
// visibleFields() cascade; phones read the mobile list and then the portal
// list they are sitting on.
const SURFACE_SETTINGS = {
  portal: ['visible_fields'],
  standalone: ['visible_standalone_fields', 'visible_fields'],
  cleaning: ['visible_cleaning_fields', 'visible_standalone_fields', 'visible_fields'],
  active: ['visible_active_fields', 'visible_standalone_fields', 'visible_fields'],
  maintenance: ['visible_maintenance_fields', 'visible_standalone_fields', 'visible_fields'],
  driver: ['visible_driver_fields', 'visible_standalone_fields', 'visible_fields'],
  mobile: ['visible_mobile_fields', 'visible_fields'],
  history: ['visible_history_fields'],
  // the spanish board never read the other lists, so it does not fall back to them
  es: ['visible_es_fields'],
}

// the surfaces a board serves with `standalone` set, so their no-config set is
// the trimmed one
const STANDALONE_SURFACES = ['standalone', 'cleaning', 'active', 'maintenance', 'driver']

const VSM_SETTING_PREFIX = 'vehicle_status_management_'

function noConfigFieldKeys(surface, boardRoute, availableFields) {
  // an unset visible_history_fields renders every history column
  if (surface === 'history') return (availableFields || []).map(f => f.key)
  // phones land on the curated trio, but as the boards' own last resort
  // rather than as a Setup default
  if (surface === 'mobile') return VSM_MOBILE_DEFAULT_FIELD_KEYS
  if (surface === 'es') return VSM_ES_DEFAULT_FIELD_KEYS
  const board = VSM_BOARD_NO_CONFIG_FIELDS[boardRoute]
  // no board resolved (vsm is not enabled for the tenant yet): nothing is
  // rendering to report, so a tenant being set up gets the new-customer set
  if (!board) return VSM_MAIN_DEFAULT_FIELD_KEYS
  const drop = STANDALONE_SURFACES.includes(surface) ? board.standalone_drop : board.portal_drop
  return board.keys.filter(k => !drop.includes(k))
}

// The columns a Customize Columns modal should open on: the tenant's own
// setting for that surface when they have one, the setting their board falls
// back to when they do not, and finally the columns the board renders with no
// config at all. `boardRoute` is the tenant's board (vsmBoardRouteName).
// availableFields trims only that last case -- a stored setting is handed back
// verbatim so nothing a tenant saved disappears from the picker.
export function surfaceVisibleFieldsString(surface, model, boardRoute, availableFields) {
  for (const key of (SURFACE_SETTINGS[surface] || [])) {
    const configured = model && model[VSM_SETTING_PREFIX + key]
    if (configured && configured.trim()) return configured
  }
  return defaultVisibleFieldsString(availableFields, noConfigFieldKeys(surface, boardRoute, availableFields))
}

export const VSM_HISTORY_FIELDS = [
  { key: 'processed_time', label:'Last Updated'},
  { key: 'updated_by', label:'Updated By'},
  { key: 'vehicle_status', label:'Status'},
  { key: 'vehicle_name', label:'Vehicle'},
  { key: 'maintenance_status', label:'Maint Status'},
  { key: 'confirmed_status', label: 'Driver Confirm'},
  { key: 'confirmed_by', label: 'Confirmed By'},
  { key: 'booking_hash', label:'Booking'},
  { key: 'last_dirty_time', label:'Dirty'},
  { key: 'last_cleaned_time', label:'Cleaned'},
  { key: 'last_cleaned_number', label:'Cleaned #'},
  { key: 'last_washed_time', label:'Washed'},
  { key: 'last_washed_number', label:'Washed #'},
  { key: 'last_bathroom_cleaned_time', label:'Bathroom Cleaned'},
  { key: 'last_def_filled_time', label:'DEF Filled'},
  { key: 'last_diesel_filled_time', label:'Diesel Filled'},
  { key: 'last_fueled_time', label:'Last Fueled'},
  { key: 'last_ready_time', label:'Ready'},
  { key: 'last_out_time', label:'Last Out'},
  { key: 'last_returned_time', label: 'Returned Time'},
  { key: 'detailed_date', label:'Detailed Date'},
  { key: 'wrapped_date', label:'Wrapped Date'},
  { key: 'dump_date', label:'Dump Date'},
  { key: 'dumped_date', label:'Dumped Date'},
  { key: 'next_scheduled_time', label:'Scheduled Time'},
  { key: 'odometer', label:'Odometer'},
  { key: 'fuel_level', label:'Fuel'},
  { key: 'def_level', label:'DEF'},
  { key: 'notes', label: 'Notes'},
]

// Helper function to convert comma-delimited string to array of field objects
export function stringToFields(fieldString, allFields) {
  if (!fieldString || !allFields) return []
  const keys = fieldString.split(',').map(k => k.trim()).filter(k => k)
  return keys.map(key => {
    const field = allFields.find(f => f.key === key)
    return field || { key, label: key }
  })
}

// Helper function to convert array of field objects to comma-delimited string
export function fieldsToString(fields) {
  if (!fields || !Array.isArray(fields)) return ''
  return fields.map(f => f.key).join(',')
}

// Helper function to get available fields (not in selected list)
export function getAvailableFields(allFields, selectedFields) {
  const selectedKeys = selectedFields.map(f => f.key)
  return allFields.filter(f => !selectedKeys.includes(f.key))
}

export function maintStatusSelectValue(status, dvirCombined = false) {
  if (!status) return status
  if (dvirCombined && (status === 'PENDING_DVIR' || status === 'UNSAFE_DVIR'))
    return 'DVIR'
  return status
}

export function displayMaintStatus(status, dvirCombined = false) {
  if (!status) return status
  if (dvirCombined && (status === 'PENDING_DVIR' || status === 'UNSAFE_DVIR'))
    return 'DVIR'
  if (status.endsWith('_DVIR'))
    return status.slice(0, -5)
  return status
}
